import {alpha2ToAlpha3LanguageCode} from '@/common/constants/language';
import {LocationType} from '@/common/constants/locationType';
import {LocationPoint} from '@/common/interfaces/location';
import {generateLocationAttributeMask, LocationField} from '@/common/helpers/location/generateLocationAttributeMask';
import {parseLocationFlags} from '@/common/helpers/location/parseLocationFlags';
import {AbstractFetcher} from '@/common/services/fetcher/AbstractFetcher';

export class InformersAPI {
	constructor(private readonly fetcher: AbstractFetcher) {
		fetcher.setDefaultParams({
			method: 'POST',

			headers: {
				// Default post data type
				'Content-Type': 'application/json',

				// Add specific static XHR header required by server
				'X-Requested-With': 'XMLHttpRequest',
			},
			// Rewrite an empty body with an empty JSON object
			postData: '{}',
		});
	}

	async getSearchSuggests(searchString: string, lang: string, limit: number, locationTypes?: LocationType[]) {
		const response = await this.fetcher.fetch<{locations: any[]}>('/api/search/suggest', {
			/* eslint-disable @typescript-eslint/naming-convention */
			query: searchString,
			lang: alpha2ToAlpha3LanguageCode[lang],
			limit,
			location_types: locationTypes,
			/* eslint-enable @typescript-eslint/naming-convention */
		});

		return response.locations.map(
			(location: any): LocationPoint => ({
				id: location.id,
				type: location.type,
				flags: parseLocationFlags(location.flags),

				title: location.title,
				titleLc: location.title_lc,
				titleGc: location.title_gc,
				description: location.description,
			}),
		);
	}

	async getLocationTitles(locations: string[], lang: string) {
		const attributes = generateLocationAttributeMask(['title']);
		const response = await this.fetcher.fetch<{locations: any[]}>('/api/location/list/by_id', {
			locations,
			lang: alpha2ToAlpha3LanguageCode[lang],
			attributes,
		});

		return response.locations.map((location: any) => ({
			id: location.id as string,
			title: location.title as string,
		}));
	}

	async makeInformer(locations: string[], email: string) {
		return this.fetcher.fetch<{url: string}>('/api/informer/make', {
			locations,
			email,
		});
	}
}
